import { TweenMax } from 'gsap';

export default function onYoutubeStateChange (event) {
  if (event.data === window.YT.PlayerState.PLAYING) {
    TweenMax.to(document.querySelector('#homepage-video'), 1, {autoAlpha: 1});
  }
  if (event.data === window.YT.PlayerState.BUFFERING) {
    TweenMax.set(document.querySelector('#homepage-video'), {autoAlpha: 0});
  }
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/youtube/onYoutubeStateChange.js